import { ReactElement } from "react"

import FormPageSummary from "../formPageSummary/formPageSummary"

interface IFormPageSummary {
    title: string
    mappings: Record<string, string | number | boolean | undefined>
    onEdit?: (() => void) | undefined
    omit?: boolean
}

interface FormSummaryProps {
    summaries: IFormPageSummary[]
}

const FormSummary = ({ summaries }: FormSummaryProps): ReactElement => (
    <>
        {summaries.map(
            (summary) =>
                !summary.omit && (
                    <FormPageSummary
                        key={summary.title}
                        pageTitle={summary.title}
                        fieldMapping={summary.mappings}
                        onEdit={summary.onEdit}
                    />
                )
        )}
    </>
)

export default FormSummary
